/* eslint-disable array-callback-return */
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import React, { useEffect, useState, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import ModernTabNavigation from '../../components/ModernTabNavigation'
import RenderComponent from './RenderComponent'

import { useWindowDimensions } from 'app/hooks'
import { useUserList } from 'app/hooks/trade/userList'
import { useUserSocket } from 'app/hooks/trade/userSocket'
import { View } from 'styles/reactnative'
import { AdminUserModal } from '../../components'
import { SendModal } from '../SendModal'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 24px;
  
  @media (max-width: 768px) {
    padding: 12px;
  }
`

const ContentWrapper = styled.div`
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  min-height: calc(100vh - 200px);
`

const PageTitle = styled.h1`
  color: rgba(255, 255, 255, 0.95);
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  &::before {
    content: '';
    width: 4px;
    height: 24px;
    background: linear-gradient(180deg, #5c7cfa 0%, #c77dff 100%);
    border-radius: 2px;
  }
`

const { Content } = Layout
export const AdminUsersPage = () => {
	const { width } = useWindowDimensions()

	const socket = useUserSocket()

	const [showModal, setShowModal] = useState(false)
	const [selectedData, setSelectedData] = useState({})

	const { userlist, sendwho } = useUserList()

	useEffect(() => {
		sendwho()
	}, [])

	const location = useLocation()
	const url = location.pathname

	const items = useMemo(() => [
		{
			title: '전체회원',
			link: '/users/0',
			componentType: 'ModernMemberManagement',
			props: { title: '전체회원', type: 'ALL' }
		},
		{
			title: '거절회원',
			link: '/users/-2',
			componentType: 'ModernMemberManagement',
			props: { title: '거절회원', type: -2 }
		},
		{
			title: '신규회원',
			link: '/users/1',
			componentType: 'ModernMemberManagement',
			props: { title: '신규회원', type: 0 }
		},
		{
			title: '대기회원',
			link: '/users/-1',
			componentType: 'ModernMemberManagement',
			props: { title: '대기회원', type: -1 }
		},
		{
			title: '활동회원',
			link: '/users/2',
			componentType: 'ModernMemberManagement',
			props: { title: '활동회원', type: '1,2,3,4' }
		},
		{
			title: '파트너회원',
			link: '/users/7',
			componentType: 'ModernMemberManagement',
			props: { title: '파트너회원', type: '5' }
		},
		{
			title: '블랙회원',
			link: '/users/3',
			componentType: 'ModernMemberManagement',
			props: { title: '블랙회원', type: '-9' }
		},
		{
			title: '모투회원',
			link: '/users/4',
			componentType: 'ModernMemberManagement',
			props: { title: '모투회원', type: '-8,6' }
		},
		{
			title: '등급 및 수수료관리',
			link: '/users/5',
			componentType: 'GroupFeeManagement'
		},
		{
			title: '레퍼럴내역',
			link: '/users/6',
			componentType: 'ReferralManagement'
		},
		{
			title: '가상계좌신청회원',
			link: '/users/9',
			componentType: 'VAccount'
		},
		{
			title: '접속자수',
			link: '/users/10',
			componentType: 'UserList'
		},
	], [])

	return (
		<Layout>
			<Helmet>
				<title>ADMIN DASHBOARD</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<Content
				className="site-layout"
				style={{ padding: `0 ${width < 768 ? 5 : 50}px 10px` }}>
				{(() => {
					const currentItem = items.find((item, index) => 
						item.link === url || (url === '/users' && index === 0)
					)
					return currentItem ? (
						<View style={{ width: '100%' }}>
							<RenderComponent 
								type={currentItem.componentType} 
								props={currentItem.props}
							/>
						</View>
					) : null
				})()}
			</Content>

			<AdminUserModal
				showModal={showModal}
				setShowModal={setShowModal}
				selectedData={selectedData}
			/>
			<SendModal />
		</Layout>
	)
}
